<div class="login-container">
    <div id="firebaseui-auth-container"></div>
    <div *ngIf="showMessage">
        Please wait.......
    </div>
</div>
